import { apiClient } from './client';

export interface PendingRegistration {
  contactId: string;
  tenantId: string;
  name?: string;
  lastName?: string;
  email?: string;
  /** Teléfono verificado por Telegram (el backend nunca expone el hash ni el chat). */
  phoneNumber?: string;
  authMethod?: 'google' | 'password';
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'EXPIRED';
  createdAt: string;
}

export interface ApprovePendingInput {
  roles: string[];
  allowedRanchos?: string[];
  allowedLotes?: string[];
  /** Permisos concedibles individualmente (p. ej. `expenses:approve`). */
  permissionOverrides?: string[];
}

export async function fetchPendingRegistrations(_tenantId: string): Promise<PendingRegistration[]> {
  const res = await apiClient.get(`/api/users/pending`);
  return res.data.items;
}

export async function approvePendingRegistration(
  _tenantId: string,
  contactId: string,
  input: ApprovePendingInput,
): Promise<void> {
  await apiClient.post(`/api/users/pending/${contactId}/approve`, input);
}

export async function rejectPendingRegistration(_tenantId: string, contactId: string): Promise<void> {
  await apiClient.post(`/api/users/pending/${contactId}/reject`);
}
